(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["am-milk-product-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('am-milk-information')) {
    customElements.define('am-milk-information', class extends HTMLElement {
      connectedCallback() {
        this.media = matchMedia('(min-width: 990px)');
        this.setOverview = () => {
          this.querySelectorAll('[data-overview]').forEach(panel => { panel.open = this.media.matches; });
        };
        this.setOverview();
        this.media.addEventListener('change', this.setOverview);
      }
      disconnectedCallback() {
        this.media?.removeEventListener('change', this.setOverview);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["am-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('am-mobile-purchase')) {
    customElements.define('am-mobile-purchase', class extends HTMLElement {
      connectedCallback() {
        this.root = document.getElementById(`ProductInfo-${this.dataset.section}`);
        this.form = document.getElementById(`product-form-${this.dataset.section}`);
        this.buy = this.form?.querySelector('.product-form__submit');
        this.price = document.getElementById(`price-${this.dataset.section}`);
        if (!this.root || !this.buy || !this.price) return;
        this.output = this.querySelector('[data-mobile-price]');
        this.media = matchMedia('(max-width: 749px)');
        this.refresh = () => {
          const sale = this.price.querySelector('.price--on-sale');
          const amount = sale?.querySelector('.price-item--sale') || this.price.querySelector('.price__regular .price-item--regular');
          this.output.textContent = this.price.classList.contains('visibility-hidden') ? '' : (amount?.textContent.trim() || '');
          const passed = this.buy.getBoundingClientRect().bottom < 0;
          this.hidden = !this.media.matches || !passed || !!document.querySelector('cart-notification.active, cart-drawer.active, dialog[open]');
        };
        this.onClick = () => {
          const options = this.root.querySelector('variant-radios, variant-selects') || this.form;
          const y = options.getBoundingClientRect().top + window.scrollY - 120;
          window.scrollTo({ top: Math.max(0, y), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          const focus = options.querySelector('select, input:checked, button, input:not([type="hidden"])');
          if (focus) focus.focus({ preventScroll: true });
          this.hidden = true;
        };
        this.querySelector('button').addEventListener('click', this.onClick);
        this.observer = new MutationObserver(this.refresh);
        this.observer.observe(this.price, { subtree: true, childList: true, characterData: true, attributes: true });
        this.observer.observe(this.buy, { attributes: true, childList: true, subtree: true });
        document.querySelectorAll('cart-notification, cart-drawer, dialog').forEach(el => this.observer.observe(el, { attributes: true }));
        window.addEventListener('scroll', this.refresh, { passive: true });
        this.media.addEventListener('change', this.refresh);
        this.refresh();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.refresh) window.removeEventListener('scroll', this.refresh);
        this.media?.removeEventListener('change', this.refresh);
        this.querySelector('button')?.removeEventListener('click', this.onClick);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["am-personalisation-total"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('am-personalisation-total')) {
    customElements.define('am-personalisation-total', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.product__info-container');
        this.output = this.querySelector('[data-selection-price]');
        if (!this.root || !this.output) return;
        this.refresh = () => {
          this.frame = null;
          const source = this.root.querySelector('[id^="price-"]');
          const sale = source?.querySelector('.price--on-sale');
          const amount = sale?.querySelector('.price-item--sale') || source?.querySelector('.price__regular .price-item--regular');
          const text = amount?.textContent.trim() || '';
          const hasOptions = !!this.root.querySelector('.po-optionItem-inner');
          const hidden = !hasOptions || !text || source?.classList.contains('visibility-hidden');
          if (this.output.textContent !== text) this.output.textContent = text;
          if (this.hidden !== hidden) this.hidden = hidden;
        };
        this.schedule = () => { if (this.frame == null) this.frame = requestAnimationFrame(this.refresh); };
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden'] });
        this.refresh();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.frame != null) cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
